import { RootState } from "../../reducers";
import { useSelector } from "react-redux";
import { MarketContainer } from "./styles";
import MatchCard from "./components/MatchCard";
import PlayerCard from "./components/PlayerCard";
import { marketDataType } from "../../types/marketFilter";

// TODO: event should accept market data or player data
interface Props {
  event?: any;
}

function FixtureDisplay({ event }: Props) {
  // TODO: sort marketcards based on what is set in the games filter
  // const filterStore = useSelector((state: RootState) => state.filter);
  // const currentGamesFilter = filterStore?.gamesFilter;
  const filterStore = useSelector((state: RootState) => state.filter);
  const marketNames = filterStore.configData.markets.map((i: marketDataType) => i.name);

  if (!event) return null;

  return (
    <MarketContainer>
      {marketNames.includes(event.marketName) ? <MatchCard {...event} /> : <PlayerCard {...event} />}
    </MarketContainer>
  );
}

export default FixtureDisplay;
